import { TLabelValue } from '@/types/misc.ts';
import { getCountries } from 'react-phone-number-input';

const countryOpts: TLabelValue[] = getCountries().map((countryCode) => ({
  label: new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode) || countryCode,
  value: countryCode,
}));

const gb = countryOpts.findIndex((c) => c.value === 'GB');

if (gb) {
  const gbCopy = { ...countryOpts[gb] };
  countryOpts.splice(gb, 1);
  countryOpts.unshift(gbCopy);
}
const us = countryOpts.findIndex((c) => c.value === 'US');
if (us) {
  const usCopy = { ...countryOpts[us] };
  countryOpts.splice(us, 1);
  countryOpts.unshift(usCopy);
}

const timezoneOpts: TLabelValue[] = Intl.supportedValuesOf('timeZone').map((tz) => ({
  label: tz,
  value: tz,
}));

export { countryOpts, timezoneOpts };
